export function getPinSection(path: string) {
  return path.split('/')[1] ?? '';
}
